module.exports = __webpack_public_path__ + "img/borderBracketsWhite.b52da65f.svg";